import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { NBHYPHEN } from '@r1-frontend/ui-react/tokens/symbols';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import {
    SquareBanner,
    WideSmallBanner,
} from '~/src/features/internetV2/components/banners';
import Carousel from '~/src/features/internetV2/components/Carousel';
import DoubleColumnContainer from '~/src/features/internetV2/components/DoubleColumnContainer';
import FlexibleListContainer from '~/src/features/internetV2/components/FlexibleListContainer';
import FastInternet from '~/static/images/internet/v2/banners/main/fast-internet.jpeg';
import FastInternetWebp from '~/static/images/internet/v2/banners/main/fast-internet.webp';
import Wifi6 from '~/static/images/internet/v2/banners/main/wifi-6.jpeg';
import Wifi6Webp from '~/static/images/internet/v2/banners/main/wifi-6.webp';

import { speed, statistics } from './data';

type TProps = {
    onBannerClick: (name: string) => void,
}

export const InternetBenefitsContainer = ({ onBannerClick }: TProps) => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    return (
        <DoubleColumnContainer>
            <FlexibleListContainer
                $direction={'column'}
                $desktop={32}
                $mobile={16}
                $tablet={16}
            >
                <SquareBanner
                    backgroundImage={FastInternet}
                    backgroundImageWebp={FastInternetWebp}
                    title={<>Cтабильное&nbsp;соединение и&nbsp;низкий пинг</>}
                    description={
                        <>
                            Скачивайте фильмы и&nbsp;сериалы, играйте онлайн
                            и&nbsp;работайте в&nbsp;интернете без зависаний
                        </>
                    }
                    buttonText={'Выбрать тариф'}
                    buttonHref={'#Tariffs'}
                    onButtonClick={() => onBannerClick('Низкий пинг и стабильное соединение')}
                />
                <Carousel>{speed.map(WideSmallBanner)}</Carousel>
            </FlexibleListContainer>

            <FlexibleListContainer
                $direction={'column'}
                $desktop={32}
                $mobile={16}
                $tablet={16}
                $reverse={isMobile}
            >
                <Carousel>{statistics.map(WideSmallBanner)}</Carousel>
                <SquareBanner
                    backgroundImage={Wifi6}
                    backgroundImageWebp={Wifi6Webp}
                    title={<>С&nbsp;новым Wi{NBHYPHEN}Fi&nbsp;6 интернета хватит всем</>}
                    description={
                        <>
                            До&nbsp;50&nbsp;устройств одновременно в&nbsp;любой точке дома
                            и&nbsp;скорость не&nbsp;упадет
                        </>
                    }
                    buttonText={'Выбрать тариф'}
                    buttonHref={'#Tariffs'}
                    onButtonClick={() => onBannerClick('С новым Wi-Fi 6 интернета хватит всем')}
                />
            </FlexibleListContainer>
        </DoubleColumnContainer>
    );
};
